import { PPC_CLOSE } from '../../shared-components/ClosePage/ClosePageConstants';

export const PAGE_NAME = {
    NEWCUST_PAGE: 'newcust',
    CYCOCORE_PAGE: 'cycocorepage',
    BILLING_PAGE: 'billinginfopage',
    PERSONAL_INFO_PAGE: 'personalinfopage',
    TERMS_PAGE: 'termspage',
    DECISION_PAGE: 'decisionpage',
    ERROR_PAGE: 'errorpage',
    INELIGIBLE_PAGE: 'ineligible',
    CLOSE_PAGE: PPC_CLOSE,
    LANDING_PAGE: 'landingpage',
    CYCO_CORE_PAGE: 'cycocorepage',
    CYCO_PAGE: 'cycopage',
    CONTINUE_PAGE: 'continuepage'
};

export const REDIRECT_SUFFIX = {
    PAY_IN_FULL_REDIRECT: 'payInFullNowFlow',
    CANCEL_REDIRECT: 'cancelFlow',
    LOGIN_REDIRECT: 'loginRedirectFlow',
    RETURN_REDIRECT: 'returnFlow'
};
